import { render, staticRenderFns } from "./CmgSessionExpiredBar.vue?vue&type=template&id=4f2dccae&scoped=true&lang=pug&"
import script from "./cmg-session-expired-bar.ts?vue&type=script&lang=ts&"
export * from "./cmg-session-expired-bar.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSessionExpiredBar.vue?vue&type=style&index=0&id=4f2dccae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2dccae",
  null
  
)

export default component.exports